/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { FlexContainer, Divider, Text, SimpleGrid, Image, ArrowLink } from "@carrotfertility/carotene"
import { ExpertBio } from "components/read/shared/ExpertBioMapper"
import { useHistory } from "react-router"
import { FormattedMessage, useIntl } from "react-intl"

export const Moderators = ({
  moderators,
  groupPath
}: {
  moderators: ExpertBio[]
  groupPath: { path: string; title: string }
}): JSX.Element => {
  const history = useHistory()
  const intl = useIntl()

  return (
    <FlexContainer direction="column" gap="large">
      <FlexContainer direction="row" alignItems="center" gap="small">
        <Text sx={{ whiteSpace: "nowrap" }} size="small">
          <FormattedMessage defaultMessage="Meet our facilitators" />
        </Text>
        <Divider sx={{ maxWidth: "600px", width: "100%" }} color="black10" />
      </FlexContainer>
      <FlexContainer>
        <SimpleGrid columns={[1, 1, 2, 2]} spacingY={["large"]} spacingX="huge">
          {moderators?.map(({ id, slug, headshot, name, credentials }) => {
            const altText = intl.formatMessage({ defaultMessage: "Headshot of {expertName}" }, { expertName: name })
            return (
              <FlexContainer gap="small" key={id}>
                <Image
                  src={headshot?.file?.url}
                  altText={altText}
                  height="60px"
                  width="60px"
                  sx={{ borderRadius: "8px" }}
                />
                <FlexContainer direction="column">
                  <Text font="publicoText" color="black80" size="17px">
                    {name}
                  </Text>
                  <Text color="black80" size="small">
                    {credentials}
                  </Text>
                  <ArrowLink
                    id="moderator-textlink"
                    variant="no-underline"
                    data-expert-id={`${slug}-${id}`}
                    onClick={() => history.push(`/read/bio/${slug}`, groupPath)}
                    style={{ paddingTop: "8px" }}
                  >
                    <FormattedMessage defaultMessage="About the expert" />
                  </ArrowLink>
                </FlexContainer>
              </FlexContainer>
            )
          })}
        </SimpleGrid>
      </FlexContainer>
    </FlexContainer>
  )
}
